import { render, staticRenderFns } from "./ExplainQuestion.vue?vue&type=template&id=eb789ae4"
import script from "./ExplainQuestion.vue?vue&type=script&lang=js"
export * from "./ExplainQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports